import { SegmentedControl } from "./ui/segmented-control";

export type TopLevelMode = 1 | 2;

const OPTIONS: ReadonlyArray<{ value: TopLevelMode; label: string }> = [
  { value: 1, label: "模式一: 直接上传" },
  { value: 2, label: "模式二: 选择练习" },
];

export interface ModeTabsProps {
  value: TopLevelMode;
  onChange: (value: TopLevelMode) => void;
}

/** Top-level mode selector on the home page: 模式一 (直接上传) vs 模式二 (选择练习). */
export function ModeTabs({ value, onChange }: ModeTabsProps) {
  return (
    <SegmentedControl<TopLevelMode>
      role="tablist"
      ariaLabel="上传模式"
      value={value}
      options={OPTIONS}
      onChange={onChange}
      size="default"
    />
  );
}